/**
 * Custom React hook for detecting user's geographic location
 * Used to determine if PayStack payment option should be shown
 */
import { useState, useEffect } from 'react';

const useLocationDetection = () => {
  const [userLocation, setUserLocation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isNigerian, setIsNigerian] = useState(false);

  useEffect(() => {
    const detectLocation = async () => {
      try {
        // Method 1: Try IP-based geolocation (most reliable for country detection)
        await detectLocationByIP();
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    const detectLocationByIP = async () => {
      try {
        // Using ipapi.co for free IP-based geolocation
        const response = await fetch('https://ipapi.co/json/');
        
        if (!response.ok) {
          throw new Error('Failed to detect location');
        }
        
        const data = await response.json();
        
        const countryCode = data.country_code;
        const country = data.country_name;
        
        setUserLocation({
          latitude: data.latitude,
          longitude: data.longitude,
          country,
          countryCode
        });
        
        // Check if user is in Nigeria
        setIsNigerian(countryCode === 'NG');
        setLoading(false);
      } catch (err) {
        // Fallback: assume non-Nigerian if detection fails
        setError(err.message);
        setIsNigerian(false);
        setLoading(false);
      }
    };

    detectLocation();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { userLocation, isNigerian, loading, error };
};

export default useLocationDetection;
